import {userConstants} from '../../_constants';

export function orders(state = {}, action) {
  switch (action.type) {
    case userConstants.LOGIN_SUCCESS:
      return {};
    case userConstants.GET_ORDER_LIST_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case userConstants.GET_ORDER_LIST_SUCCESS:
      return {
        ...state,
        ...action.data,
        loading: false,
      };
    case userConstants.GET_ORDER_LIST_FAILURE:
      return {
        error: action.error,
      };

    default:
      return state;
  }
}
